import React, { useEffect } from "react";
import AddExpenses from "./AddExpenses";
import { useExpensesContext } from "../../../context/expenses_context";
import { naira } from "../../../utils/data";
import { th } from "../../../utils/helpers";
import CustomTable from "../../../utils/CustomTable";

export default function AllExpenses() {


      const {
            expensesLoading, openAddExpenses,
            getExpensesData, expensesData
      } = useExpensesContext();


      useEffect(() => {
            getExpensesData();
      }, []);

      useEffect(() => {
            const expenses = expensesData?.map(({ id, agentData, time, amount, details, suppData, ecData }, i) => {
                  const category = ecData?.name;
                  const supplier = suppData?.name || 'Nil';
                  return (
                        {
                              sn: i + 1,
                              id,
                              agentData,
                              category,
                              details,
                              supplier,
                              amount: naira + th(amount || 0),
                              time,
                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  rows:
                        expenses
            });
      }, [expensesData]);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                  },
                  {
                        label: "ID",
                        field: "id",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "time",
                        width: 200,
                  },
                  {
                        label: "Agent",
                        field: "agentData",
                        width: 270,
                  },
                  {
                        label: "Category",
                        field: "category",
                        width: 270,
                  },
                  {
                        label: "Details",
                        field: "details",
                        width: 270,
                  },
                  {
                        label: "Supplier",
                        field: "supplier",
                        width: 270,
                  },
                  {
                        label: "Amount",
                        field: "amount",
                        width: 270,
                  },
            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Expenses"}
                              loading={expensesLoading}
                              getData={getExpensesData}
                              openAddModal={openAddExpenses}
                              addTitle={"Add Expenses"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Expenses Modal */}
                  <AddExpenses
                  />
                  {/* Add Expenses Modal */}

            </>

      );
}
